import React from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/material.css";
import { FormHelperText, Box } from "@mui/material";

const CustomPhoneInput = ({
  name,
  value,  // This should receive the FULL phone number (with country code)
  onChange,
  onBlur,
  error,
  helperText,
  ...rest
}) => {
  return (
    <Box>
      <PhoneInput
        country={"us"}
        countryCodeEditable={false}
        disableSearch={true}
        value={value}  // Now receives full number including country code
        onChange={(phone, countryData) => {
          const countryCode = countryData?.dialCode || "";
          // Pass both values to parent
          onChange(name, { 
            countryCode,
            phone: phone.replace(countryCode, "") 
          });
        }}
        onBlur={onBlur}
        inputProps={{
          name,
          autoFocus: false,
          onBlur
        }}
        inputStyle={{
          width: "100%",
          borderRadius: "20px",
          background: "#f3f3f3",
          border: "none",
          outline: "none",
        //   height: "48px",
        }}
        buttonStyle={{
          borderRadius: "20px 0 0 20px",
          border: "none",
          background: "#f3f3f3",
        }}
        {...rest}
      />
      {error && (
        <FormHelperText error sx={{ ml: 0.5, fontSize: "12px", mb: 2 }}>
          {helperText}
        </FormHelperText>
      )}
    </Box>
  );
};

export default CustomPhoneInput;